"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ({ projectId }) => {
    return {
        schemaType: "object",
        properties: [
            {
                title: "言語",
                propertyName: "langId",
                schema: {
                    schemaType: "externalKey",
                    resourcePath: "translation_lang",
                    titleKey: "langName",
                },
            },
            {
                title: "詳細",
                propertyName: "description",
                schema: {
                    schemaType: "text",
                },
            },
            {
                title: "別名",
                propertyName: "aliases",
                schema: {
                    schemaType: "array",
                    item: {
                        schemaType: "text",
                    },
                },
            },
        ],
    };
};
